import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { defaultVariant, defaultProductOption } from '@utils/recordHelpers';
import { tAttribute } from '@utils';

import { Card, FormLayout, Stack, Button, Select, Tag, ResourceList,ResourceItem, TextStyle, InlineError } from '@shopify/polaris';
import { TagsInputA } from '@presentational/';

import { FieldArray } from 'formik';
import TagsInput from 'react-tagsinput';


const propTypes = {
  options: PropTypes.array,
  variantTypes: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  currency: PropTypes.string,
  onVariantClick: PropTypes.func.isRequired,
  handleOptionValuesChange: PropTypes.func.isRequired,
  reloadVariants: PropTypes.func.isRequired,

  experimental: PropTypes.object,
  readOnly: PropTypes.bool,
  apb: PropTypes.bool.isRequired,
  canEditOptions: PropTypes.bool,
  errors: PropTypes.object,
  // addVariantURL: PropTypes.string,
};

const defaultProps = {
  currency: "₡",
  readOnly: false,
  canEditOptions: false,
}


class ProductFormVariants extends Component {
  constructor(props) {
    super(props);
    this.state={
      selectedItems: []
    }
  }
  
  handleSelectionChange = (selectedItems) => {
    this.setState({ selectedItems });
  };

  renderVariant = (variant) => {
    let { currency, onVariantClick, readOnly, apb } = this.props;
    return(
      <ResourceItem
        id={variant.id}
        onClick={ readOnly ? null : onVariantClick }
      >
        <div className="flex justifyBetween">
          <div>
            <h3>
              <TextStyle variation="strong">
                { variant.title }
              </TextStyle>
            </h3>
            <div>{variant.sku}</div>
          </div>

          <div>
            <div>
              { tAttribute("variant", "price") }: {currency} { variant.price }
            </div>
            <div>
              { tAttribute("variant", "unit_cost") }: {currency} { variant.unit_cost }
            </div>
            { !apb &&
              <div>{variant.inventory_quantity || 0 } available</div>
            }
          </div>
        </div>
      </ResourceItem>
    )
  }

  bulkActions = () => {
    return [
      {
        content: 'Edit prices',
        onAction: () => console.log('Todo: implement bulk add tags'),
      },
      {
        content: 'Edit quantities',
        onAction: () => console.log('Todo: implement bulk remove tags'),
      },
      {
        content: 'Edit SKUs',
        onAction: () => console.log('Todo: implement bulk delete'),
      },
      {
        content: 'Edit barcodes',
        onAction: () => console.log('Todo: implement bulk delete'),
      },
    ];
  }

  render() {
    let props = this.props;
    // const items = props.variants.map( (variant, index) => ({
    //   id: index,
    //   name: variant.title,
    // }))
    const resourceName = {
      singular: I18n.t("activerecord.models.variant", { count: 1 }),
      plural: I18n.t("activerecord.models.variant", { count: 2 })
    }
    return (
      <div>
        { props.canEditOptions &&
          <FieldArray
          name="options"
          render={arrayHelpers => (
            <Card.Section title={I18n.t("shopify.options")}>
              <InlineError message={ props.errors && props.errors.options } />
                { props.options.map((productOption, index) => {
                  let emptyValues = productOption.values.length < 1;
                  return (
                  <FormLayout key={index}>

                    <Stack>
                      <Stack.Item fill>
                        <strong>
                          {I18n.t("shopify.option")} {index + 1}
                        </strong>
                      </Stack.Item>
                      { !props.readOnly &&
                        <Stack.Item>
                          <Button
                            onClick={ async () => {
                              await arrayHelpers.remove(index);
                              props.reloadVariants();
                            }}
                            plain>
                            {I18n.t("actions.remove")}
                          </Button>
                        </Stack.Item>
                      }
                    </Stack>

                    <FormLayout.Group condensed>
                      <Select
                        disabled={ props.readOnly }
                        id={`options.${index}.name`}
                        name={`options.${index}.name`}
                        options={props.variantTypes}
                        onChange={props.handleChange}
                        value={productOption.name}
                      />

                      {/* <TagsInputA
                        name={`options.${index}.values`}
                        tags={ productOption.values }
                        value={productOption.values.join(",")}
                        labelHidden
                        placeholder={I18n.t("form.placeholder.variant.value")}
                        multiline
                        handleChange={ props.handleOptionValuesChange }
                        onRemove={() => true}
                      /> */}

                      {/* Needs a validationregex to remove commas and other troublesome signs */}
                      <TagsInput
                        disabled={ props.readOnly }
                        value={productOption.values}
                        onlyUnique
                        addKeys={[188, 9, 13]}
                        inputProps={{
                          className: `react-tagsinput-input ${emptyValues ? 'show-placeholder' : ''}`,
                          placeholder: emptyValues ? I18n.t("form.placeholder.variant.value") : '',
                        }}
                        onChange={(tags) => props.handleOptionValuesChange(`options.${index}.values`, tags) } />

                    </FormLayout.Group>
                    <hr />
                  </FormLayout>
                )})}
                { props.options.length < 3 && !props.readOnly &&
                  <Button
                    onClick={() => arrayHelpers.push(defaultProductOption)} >
                    {I18n.t("actions.add_x", { x: I18n.t("shopify.option") } )}
                  </Button>
                }
              </Card.Section>
            )}
          />
        }

        { props.variants && props.variants.length > 0 &&
          <Card.Section title={ I18n.t("app.preview") }>
            <ResourceList
              resourceName={ resourceName }
              items={ props.variants }
              renderItem={this.renderVariant}
            />
              {/* TODO . For time optimization reasons bulk actions are disabled right now */}
              {/* selectedItems={this.state.selectedItems}
              onSelectionChange={this.handleSelectionChange}
              bulkActions={ props.readOnly ? null : this.bulkActions()} */}
          </Card.Section>
        }
      </div>
    );
  }
}


ProductFormVariants.propTypes = propTypes;
ProductFormVariants.defaultProps = defaultProps;


export default ProductFormVariants;
